import { styled, Container, Box, useTheme } from "@mui/material";
import { Outlet, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector, AppState } from "@/redux/store";
import HeaderLayout from "@/layouts/create/header/Header";
import { getCookie } from "@/utils";
import { useAuth } from "@/hooks/auth.hooks";
import { useThemeContext } from "@/context/ThemeContext";

const MainWrapper = styled("div")(() => ({
  display: "flex",
  minHeight: "100vh",
  width: "100%",
  backgroundColor: "#e6e8ec"
}));

const PageWrapper = styled("div")(() => ({
  display: "flex",
  flexGrow: 1,
  paddingBottom: "43px",
  flexDirection: "column",
  zIndex: 1,
  width: "100%",
  backgroundColor: "transparent"
}));

const CreateLayout = () => {
  const theme = useTheme();
  const customizer = useSelector((state: AppState) => state.customizer);

  //theme
  const { theme: customTheme, toggleTheme } = useThemeContext();

  const isAuthenticatedCreateLayout = () => {
    const accessToken = localStorage.getItem("xsm_access_token");
    return !!accessToken;
  };

  return (
    <MainWrapper>
      {isAuthenticatedCreateLayout() ? (
        <PageWrapper
          className="page-wrapper"
          sx={{
            ...(customizer.isCollapse && {
              [theme.breakpoints.up("lg")]: {
                ml: `${customizer.MiniSidebarWidth}px`
              }
            })
          }}
        >
          <HeaderLayout toggleTheme={toggleTheme} customTheme={customTheme} />
          <Container
            maxWidth={false}
            sx={{ padding: 0, margin: 0, paddingRight: "16px !important" }}
          >
            <Box sx={{ minHeight: "calc(100vh - 170px)" }}>
              <Outlet />
            </Box>
          </Container>
        </PageWrapper>
      ) : (
        <Navigate to="/" replace />
      )}
    </MainWrapper>
  );
};

export default CreateLayout;
